const documentTemplate = `<!DOCTYPE html>
<html>
  <head>
    
  </head>
  <body>
    <div id="appraisalValues">
    <div class="heading"><h6>Documents</h2></div>

      <table>
        <tr class="leftAlign">
          <th>File Name</th>
          <th>Uploaded By</th>
          <th>Uploaded Date</th>
        </tr>
        {{#each doc}}
        <tr>
          <td>{{this.fileName}}</td>
          <td>{{this.lastModifiedBy}}</td>
          <td>{{this.lastModifiedDate}}</td>
        </tr>
        {{/each}}
        {{#if (eq this.empty 'true')}}
        <tr>
          <td colspan="3">No  Data</td>
        </tr>
        {{/if}}
      </table>
    </div>
  </body>
</html>
`;
export default documentTemplate; 

// <style>
//       body {
//         font-family: Roboto, Helvetica, Arial, sans-serif;
//       }
//       table,
//       th,
//       td {
//         border: none;
//         padding-top: 10px;
//       }
//       table {
//         width: 100%;
//         border-radius: 3px !important;
//       }
//       th,
//       td {
//         padding: 15px;
//       }
//       .border {
//         width: 100%;
//         border: 0.5px solid #263746;
//         border-radius: 3px;
//       }

//       .heading {
//         margin: 0 !important;
//         background-color: #263746;
//         color: #fff;
//         padding: 10px;
//       }

//       th > .leftAlign {
//         align-items: left !important;
//         justify-content: left !important;
//         text-align: left !important;
//       }

//       .headerClass {
//         background-color: grey;
//       }
//     </style>